import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../Containers/Config/index.js';
import { GET_AIRPORTS_LIST, GET_AIRPORTS_LIST_SUCCESS, GET_AIRPORTS_LIST_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getAirportList({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/airports`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload?.urlParam,
        projectId: payload?.urlParam?.projectId,
        bookingTypeId: payload?.urlParam?.bookingTypeId,
        pageIndex: payload?.urlParam?.pageIndex,
        pageSize: Constant?.TABLE_PAGE_SIZE,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: GET_AIRPORTS_LIST_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_AIRPORTS_LIST_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_AIRPORTS_LIST_ERROR, payload: error });
  }
}

export function* watchAirportList() {
  yield takeEvery(GET_AIRPORTS_LIST, getAirportList);
}

function* airportListSaga() {
  yield all([fork(watchAirportList)]);
}

export default airportListSaga;
